import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["absolute bg-rose-500 w-1.5 h-1.5 rounded-full animate-ping origin-center", _ctx.offsetClasses])
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["absolute bg-rose-500 w-1.5 h-1.5 rounded-full", _ctx.offsetClasses])
        }, null, 2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}